module.exports = __webpack_public_path__ + "static/media/search.32187100.png";